<template>
  <div v-for="(data, index) in dataSource" :key="data.nameDay">
    <div class="display-flex justify-content--start list__item">
      <p class="semibold-12 list__name">
        {{ data.nameDay }}
      </p>
      <div class="display-inline">
        <a-tooltip placement="right">
          <template #title v-if="disabled && isSequence">
            <div>Es necesario inactivar la secuencia para poder modificar.</div>
          </template>
          <range-picker
            v-for="(range, index) in data.hours"
            :key="range.id"
            ref="rangePicker"
            :id-picker="range.id"
            @onChangePicker="handleChangePicker"
            :order-day="data.order"
            :show-icon-remove="index !== 0"
            @onRemove="$emit('onRemoveRange', data.order, range.id)"
            :hour-start="range.start"
            :hour-end="range.end"
            :disabled-hours="disabledHours(data.hours, index)"
            :disabled-minutes="disabledMinutes(data.hours)"
            :disabled="disabled"
            :is-sequence="isSequence"
            :tooltip="tooltip"
          />
          <a-tooltip placement="right">
            <template #title v-if="disabled && tooltip">
              {{ tooltip }}
            </template>
            <a-button
              type="link"
              class="button"
              :disabled="disabled"
              @click="$emit('onAddRange', data.order)"
            >
              <PlusOutlined />
              Agregar nuevo horario
            </a-button>
          </a-tooltip>
        </a-tooltip>
      </div>
    </div>
    <a-divider
      v-if="index < dataSource.length - 1"
      :key="`divider-${data.nameDay}`"
      class="list__divider"
    />
  </div>
</template>

<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import moment from "moment";

import RangePicker from "@/app/chatbots/components/organisms/RangePicker.vue";

export default {
  name: "ListRangePickers",
  components: { RangePicker, PlusOutlined },
  props: {
    isSequence: {
      required: false,
      type: Boolean,
      default: false,
    },
    fromTreeSection: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: () => [
        {
          day: "Lunes",
          order: 0,
          hours: [
            {
              key: "key-lunes-1",
              start: "04/02/2021 12:00:00",
              end: "04/02/2021 13:00:00",
            },
            {
              key: "key-lunes-2",
              start: "04/02/2021 12:00:00",
              end: "04/02/2021 13:00:00",
            },
          ],
        },
        {
          day: "Martes",
          order: 1,
          hours: [
            {
              key: "key-martes-1",
              start: "04/02/2021 12:00:00",
              end: "04/02/2021 13:00:00",
            },
          ],
        },
      ],
    },
    tooltip: {
      type: String,
      default: null,
    }
  },
  data: () => ({
    timeFormat: moment.HTML5_FMT.TIME_SECONDS,
  }),
  computed: {},
  methods: {
    range(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    },
    handleChangePicker(idRange, range, order, type) {
      let hour = null;
      if (type === "start") hour = range.start;
      if (type === "end") hour = range.end;

      console.log("HORA", hour);
      this.$emit("onChangeRange", order, idRange, range);
      console.log("ListRange", hour);
    },
    async handleSubmitRangesPromise() {
      const promises = this.$refs.rangePicker.map((range) => {
        return range.validateRangePicker();
      });
      return await Promise.all(promises);
    },
    async handleSubmitRanges() {
      this.$refs.rangePicker.forEach((range) => {
        range.handleSubmit();
      });
    },
    disabledHours(ranges, index) {
      const disabledHours = [];

      const availableRanges = ranges.slice(0, index);

      availableRanges.forEach((range) => {
        const timeStart = {
          hour: moment(range.start, this.timeFormat).hours(),
          minute: moment(range.start, this.timeFormat).minutes(),
        };

        const timeEnd = {
          hour: moment(range.end, this.timeFormat).hours(),
          minute: moment(range.end, this.timeFormat).minutes(),
        };

        for (let index = 0; index < 24; index++) {
          // Deshabilita todas las horas antes de timeStart
          if (range.start && index >= timeStart.hour && range.end && index <= timeEnd.hour) {
            disabledHours.push(index);
          }

          // Deshabilita la hora de inicio en la lista de horas de final
          if (range.end && index === timeStart.hour) {
            disabledHours.push(index);
          }

          // Deshabilita la hora de inicio en la lista de horas de inicio
          if (range.start && index === timeStart.hour) {
            disabledHours.push(index);
          }
        }
      });

      return disabledHours;
    },
    disabledMinutes(ranges) {
      // console.log("143------ ListRange", ranges);
      const disabledMinutes = [];

      ranges.forEach((range) => {
        const timeStart = {
          hour: moment(range.start, this.timeFormat).hours(),
          minute: moment(range.start, this.timeFormat).minutes(),
        };

        const timeEnd = {
          hour: moment(range.end, this.timeFormat).hours(),
          minute: moment(range.end, this.timeFormat).minutes(),
        };
        if (timeStart.hour === timeEnd.hour) {
          for (let index = 0; index < timeStart.minute; index++) {
            disabledMinutes.push(index);
          }
        }
      });
      return disabledMinutes;
    },
  },
};
</script>

<style lang="sass" scoped>
.list-scroll
  overflow-y: scroll

.list__item
  padding: 8px
.list__divider
  margin-top: 12px
  margin-bottom: 12px
.list__name
  width: 80px
.display-flex
  display: flex
.display-inline
  display: inline-block

.button
  padding: 0
  height: 22px
</style>
